import { axiosObject } from "../config";

export default function forgotPassword(form: any, prefix_url: any) {
  let payload = {
    type: "email",
    value: form.value.email.toLocaleLowerCase(),
    verification_method: "link",
    prefix_url: prefix_url,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/request-reset-password";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        console.log("check here error", errors);
        if (errors.response.status === 422) {
          form.setErrors({ email: errors.response.data.errors.value });
          reject(errors.response.data.errors);
        }
        reject(errors);
      });
  });
}
